var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDailyCheckedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5409 62.6991V59.6326H24V62.6991C24 62.7193 24 62.7379 24 62.7581C24 65.6508 36.8117 65.7341 38.2726 65.7341C39.7334 65.7341 52.5451 65.6508 52.5451 62.7581C52.5451 62.7379 52.5423 62.7193 52.5409 62.6991Z",
    fill: "#FFBB45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5451 62.7581C52.3707 65.5919 39.7237 65.7342 38.2726 65.7342C36.8214 65.7342 24.18 65.5589 24 62.7251C24 62.7251 24 63.0039 24 63.024C24 65.9167 36.8117 66 38.2726 66C39.7334 66 52.5451 65.9167 52.5451 63.024V62.7581Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4979_559",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 59,
    width: 29,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5409 62.6991V59.6326H24V62.6991C24 62.7193 24 62.7379 24 62.7581C24 65.6508 36.8117 65.7341 38.2726 65.7341C39.7334 65.7341 52.5451 65.6508 52.5451 62.7581C52.5451 62.7379 52.5423 62.7193 52.5409 62.6991Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4979_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1674 59.8768H23.7251V65.9899H24.1674V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1874 59.8768H24.7451V65.9899H25.1874V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2073 59.8768H25.765V65.9899H26.2073V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2273 59.8768H26.785V65.9899H27.2273V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2473 59.8768H27.805V65.9899H28.2473V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2673 59.8768H28.825V65.9899H29.2673V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2872 59.8768H29.8449V65.9899H30.2872V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3072 59.8768H30.8649V65.9899H31.3072V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3271 59.8768H31.8848V65.9899H32.3271V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3457 59.8768H32.9034V65.9899H33.3457V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3657 59.8768H33.9234V65.9899H34.3657V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3857 59.8768H34.9434V65.9899H35.3857V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4056 59.8768H35.9633V65.9899H36.4056V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4256 59.8768H36.9833V65.9899H37.4256V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4455 59.8768H38.0032V65.9899H38.4455V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4655 59.8768H39.0232V65.9899H39.4655V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4855 59.8768H40.0432V65.9899H40.4855V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5055 59.8768H41.0632V65.9899H41.5055V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5254 59.8768H42.0831V65.9899H42.5254V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5454 59.8768H43.1031V65.9899H43.5454V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5654 59.8768H44.123V65.9899H44.5654V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5853 59.8768H45.143V65.9899H45.5853V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6053 59.8768H46.163V65.9899H46.6053V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6252 59.8768H47.1829V65.9899H47.6252V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6453 59.8768H48.2029V65.9899H48.6453V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6652 59.8768H49.2229V65.9899H49.6652V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6852 59.8768H50.2429V65.9899H50.6852V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7051 59.8768H51.2628V65.9899H51.7051V59.8768Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7237 59.8768H52.2814V65.9899H52.7237V59.8768Z",
    fill: "#E3931B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2726 62.5669C46.1551 62.5669 52.5451 61.3851 52.5451 59.9271C52.5451 58.4692 46.1551 57.2874 38.2726 57.2874C30.39 57.2874 24 58.4692 24 59.9271C24 61.3851 30.39 62.5669 38.2726 62.5669Z",
    fill: "#E3931B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2726 62.2796C46.1551 62.2796 52.5451 61.0977 52.5451 59.6398C52.5451 58.1819 46.1551 57 38.2726 57C30.39 57 24 58.1819 24 59.6398C24 61.0977 30.39 62.2796 38.2726 62.2796Z",
    fill: "#FFE669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2726 61.4173C45.2088 61.4173 50.8317 60.6215 50.8317 59.6398C50.8317 58.658 45.2088 57.8622 38.2726 57.8622C31.3364 57.8622 25.7134 58.658 25.7134 59.6398C25.7134 60.6215 31.3364 61.4173 38.2726 61.4173Z",
    fill: "#FFBB45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2726 61.4173C45.2088 61.4173 50.8317 60.6215 50.8317 59.6398C50.8317 58.658 45.2088 57.8622 38.2726 57.8622C31.3364 57.8622 25.7134 58.658 25.7134 59.6398C25.7134 60.6215 31.3364 61.4173 38.2726 61.4173Z",
    fill: "#FFBB45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2726 58.1654C44.8486 58.1654 50.2443 58.8839 50.7871 59.7907C50.8153 59.7456 50.8308 59.6934 50.8317 59.6398C50.8317 58.6583 45.2086 57.8622 38.2726 57.8622C31.3365 57.8622 25.7148 58.6583 25.7148 59.6398C25.7162 59.6935 25.7321 59.7458 25.7609 59.7907C26.3023 58.8796 31.6965 58.1654 38.2726 58.1654Z",
    fill: "#D98A14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4493 60.9676V60.798C36.0764 60.798 34.9238 60.7578 34.0225 60.6974C32.8797 60.6198 32.3007 60.5077 32.3007 60.3612V60.3339H34.7983V60.3612C34.7983 60.4416 35.0648 60.4977 35.6117 60.5336C35.9884 60.5595 36.6066 60.5781 37.4493 60.5896V60.0306L36.8814 60.0091C35.6145 59.9602 34.6713 59.9042 34.0755 59.8453C33.2843 59.7662 32.8839 59.6656 32.8839 59.5449C32.8839 59.2776 34.4187 59.1138 37.4493 59.0779V58.9026H39.4404V59.0765C40.4702 59.0765 41.3576 59.1081 42.0762 59.1541C43.0208 59.2159 43.4994 59.2978 43.4994 59.417V59.4429H41.0129V59.4156C41.0129 59.3466 40.4981 59.3021 39.4404 59.282V59.8481L40.2525 59.8769C42.6859 59.9631 43.9208 60.1068 43.9208 60.308C43.9208 60.4517 43.4575 60.5623 42.545 60.6529C41.7259 60.7333 40.6823 60.7836 39.4404 60.7966V60.9676H37.4493ZM39.4404 60.5839C40.0572 60.5738 40.5567 60.548 40.9139 60.5077C41.3087 60.4646 41.5083 60.4057 41.5083 60.3339C41.5083 60.262 41.2836 60.2175 40.8204 60.1772C40.5302 60.1528 40.0655 60.1284 39.4404 60.1039V60.5839ZM37.4493 59.2805C35.9996 59.3121 35.302 59.3955 35.302 59.5392C35.302 59.6038 35.5378 59.6556 36.0219 59.6973C36.3149 59.7217 36.7963 59.749 37.4563 59.7749L37.4493 59.2805Z",
    fill: "#D98A14"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4493 60.6112V60.4489C36.0764 60.4489 34.9238 60.4086 34.0225 60.3483C32.8797 60.2707 32.3007 60.1572 32.3007 60.012V59.9847H34.7983V60.012C34.7983 60.0925 35.0648 60.1485 35.6117 60.1845C35.9884 60.2103 36.6066 60.229 37.4493 60.2405V59.6743L36.8814 59.6528C35.6145 59.6039 34.6713 59.5479 34.0755 59.4889C33.2843 59.4099 32.8839 59.3093 32.8839 59.1886C32.8839 58.9199 34.4187 58.7575 37.4493 58.7216V58.5463H39.4404V58.7245C40.4702 58.7245 41.3576 58.7561 42.0762 58.8021C43.0208 58.8638 43.4994 58.9458 43.4994 59.065V59.0909H41.0129V59.065C41.0129 58.996 40.4981 58.9515 39.4404 58.9314V59.4976L40.2525 59.5263C42.6859 59.6125 43.9208 59.7562 43.9208 59.9574C43.9208 60.1011 43.4575 60.2118 42.545 60.3023C41.7259 60.3828 40.6823 60.4331 39.4404 60.446V60.617L37.4493 60.6112ZM39.4404 60.2276C40.0572 60.2161 40.5567 60.1916 40.9139 60.1514C41.3087 60.1069 41.5083 60.0494 41.5083 59.9775C41.5083 59.9057 41.2836 59.8611 40.8204 59.8209C40.5302 59.7965 40.0655 59.772 39.4404 59.7476V60.2276ZM37.4493 58.9242C35.9996 58.9558 35.302 59.0392 35.302 59.1829C35.302 59.2475 35.5378 59.2993 36.0219 59.3409C36.3149 59.3654 36.7963 59.3912 37.4563 59.4185L37.4493 58.9242Z",
    fill: "#FFE669"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21773 5.60589V14.7671L1.75399 18.2406L1.59607 37.0206H73.2987V3.43994H47.7365L44.477 4.84823H5.33144L5.21773 5.60589Z",
    fill: "url(#paint0_linear_4979_559)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.884H16.2848L20.355 66.941H57.9382L61.5493 65.3186H73.7619V71.0001H17.9125L16.0132 69.1049H0V62.884Z",
    fill: "#A16409"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8476 68.855H69.5044V58.3527L72.9555 54.9128V45.1051H73.2987V55.0555L69.8476 58.4954V68.855Z",
    fill: "#A16409"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8988 33.9353H72.3553V45.1072H73.8988V33.9353Z",
    fill: "#A16409"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04718 5.71082H5.39039V14.8091L1.93929 18.2469V28.0566H1.59607V18.1063L5.04718 14.6664V5.71082Z",
    fill: "#A16409"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53939 28.0566H0.995972V39.2285H2.53939V28.0566Z",
    fill: "#A16409"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93929 39.2264H1.59607V52.3313H1.93929V39.2264Z",
    fill: "#A16409"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54798 0L1.05493 2.33176H2.8405L5.33144 0H3.54798Z",
    fill: "#A16409"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55076 0L5.05981 2.33176H6.84327L9.33422 0H7.55076Z",
    fill: "#A16409"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5535 0L9.06256 2.33176H10.846L13.337 0H11.5535Z",
    fill: "#A16409"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 0L13.0654 2.33176H14.8488L17.3419 0H15.5563Z",
    fill: "#A16409"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 0L17.0681 2.33176H18.8537L21.3446 0H19.5591Z",
    fill: "#A16409"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5639 0L21.073 2.33176H22.8565L25.3474 0H23.5639Z",
    fill: "#A16409"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5668 0L25.0758 2.33176H26.8593L29.3502 0H27.5668Z",
    fill: "#A16409"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5696 0L29.0786 2.33176H30.8621L33.353 0H31.5696Z",
    fill: "#A16409"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5723 0L33.0814 2.33176H34.8669L37.3579 0H35.5723Z",
    fill: "#A16409"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5772 0L37.0862 2.33176H38.8697L41.3606 0H39.5772Z",
    fill: "#A16409"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.58 0L41.0891 2.33176H42.8725L45.3635 0H43.58Z",
    fill: "#A16409"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1281 4.32768V20.4317L75 22.2996V2.28556H69.6917L67.464 0.0671387H49.8568L45.2939 4.61522L73.1281 4.32768Z",
    fill: "#A16409"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9699 4.32776H0.907532V6.49161H45.9699V4.32776Z",
    fill: "#A16409"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4979_559",
    x1: 37.4484,
    y1: -0.245536,
    x2: 37.4484,
    y2: 30.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3931B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26253F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDailyCheckedIn);
export default __webpack_public_path__ + "static/media/iconDailyCheckedIn.82a9b8bc961f5e61670f26c7668e7727.svg";
export { ForwardRef as ReactComponent };